import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  Typography,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Modal,
  Fade,
  Box,
  Grid,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import FormatterChecker from "./FormatChecker";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared copy/commonfunctions";
import {
  startOverAPICall,
  documentupdateAPICall,
  getDocumentTypeDropDownAPICall,
  stageDetailsAPICall,
} from "../shared copy/APICalls";
import routesData from "../shared copy/routes.json";
import StageLayout from "../Layouts/StageLayout";
import PreviewModalPopup from "../Components copy/Modals/PreviewModalPopup";
import uploadStyles from "../pages copy/Styles/Uploads.module.scss";
import icon from "../Components copy/assets/Images/iconnew.svg";
import UploadImage from "../Components copy/assets/Images/document-upload.svg";
import SnackBar from "../Components copy/SnackBars/SnackBar";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import StartOverBackDrop from "../Components copy/StartOverBackDrop";
import SucessSnackBar from "../Components copy/SnackBars/SucesssnackBar";
import BackDrop from "../Components copy/BackDrop";
import ErrorSnackBar from "../Components copy/SnackBars/ErrorSnackBar";
import { UploadSizes } from "../shared copy/constants";

const label = { inputProps: { "aria-label": "Checkbox demo" } };
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "80vH",
  bgcolor: "background.paper",
  p: 1,
  boxShadow: 24,
};

export default function UploadDocumentsPage() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [message, setmessage] = React.useState("");
  const [infoMessage, setinfoMessage] = React.useState(false);

  const [signatureDocRef, setSignatureDocRef] = useState<any>();
  const [panCardDocRef, setPanCardDocRef] = useState<any>();
 
  const [showUpload, setShowUpload] = useState(false);
  const [disableContinueOption1, setdisableContinueOption1] = useState("");
  const [disableContinueOption2, setdisableContinueOption2] = useState("");
  const [disableContinueOption3, setdisableContinueOption3] = useState("");
  const [disableContinueOption4, setdisableContinueOption4] = useState("");
  const [displayDropdownOptions, setDisplayDropdownOptions] = useState(true);
  const [completedStages, setCompletedStages] = useState<any>();

  const [signatureUrl, setsignatureUrl] = useState<any>();
  const [bankProofeUrl, setbankProofUrl] = useState<any>();
  const [pancardUrl, setpancardUrl] = useState<any>();
  const [gstUrl, setGstUrl] = useState<any>();

  const [InformationMessage, setInformationMessage] = useState("");
  const [backdrop, setBackDrop] = useState(false);
  const rupeeSymbol = String.fromCharCode(8377);
  const [uploadmessage, setUploadmessage] = useState("");
  const [backLoading, setBackDropLoading] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");

  const [bankDetails, setBankDetails] = useState({
    AccountNumber: "",
    IFSCCode: "",
  });

  const [initialdropdowndata, setinitialdropdowndata] = useState<any>([]);

  const navigationData:any = routesData;

  const chequeFormat = ["png", "jpg", "jpeg"];
  const formats = ["pdf", "png", "jpg", "jpeg"];

  const handleStartOver = () => {
    if (
      window.confirm(
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted"
      )
    ) {
      setBackDrop(true);

      startOverAPICall()
        .then((response: any) => {
          const responseData = response.data;
          //  console.log("responseData", responseData);

          setBackDrop(false);
          navigate("/mobile");
          window.location.reload();
        })
        .catch((error: any) => {
          setBackDrop(false);
        });
    }
  };

  const handleStageAPI = () => {
    setloading(true);
    documentupdateAPICall()
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData", response);
        setloading(false);
        if (
          responseData.data.stage &&
          navigationData.hasOwnProperty(responseData.data.stage)
        ) {
          navigate(navigationData[responseData.data.stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  };

  const handlePreview = (data: any) => {
    //console.log(data);
  };
  const handleDisplayOptions = (data: any) => {
    setDisplayDropdownOptions(data);
    if (data === true) {
      setInformationMessage("");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);

    setBackDropLoading(true);
    getDocumentTypeDropDownAPICall()
      .then((response: any) => {
        const responseData = response.data;

        setShowUpload(true);

        setSignatureDocRef(responseData.data.signature.docTypeRef);
        setPanCardDocRef(responseData.data.pancard.docTypeRef);
      })
      .catch((error: any) => {});
    let obj: any = {
      stage: "document_upload",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        setCompletedStages(responseData.completed_stages);

        setBackDropLoading(false);
        if (response.data.data.StageDetails.ClientDetails) {
          setBankDetails({
            AccountNumber: response.data.data.StageDetails.ClientDetails[0]
              .AccountNumber
              ? response.data.data.StageDetails.ClientDetails[0].AccountNumber
              : "",
            IFSCCode: response.data.data.StageDetails.ClientDetails[0].IFSC
              ? response.data.data.StageDetails.ClientDetails[0].IFSC
              : "",
          });
        }

        if (response.data.data.StageDetails.ErrorMessage) {
          setRejectMessage(response.data.data.StageDetails.ErrorMessage);
        }

        if (responseData.data.StageDetails.Documents.signature) {
          setdisableContinueOption1("Document Successfully Uploaded");
        }
        if (responseData.data.StageDetails.Documents.pancard) {
          setdisableContinueOption2("Document Successfully Uploaded");
        }
        if (responseData.data.StageDetails.Documents.bank_proof) {
          setdisableContinueOption4("Document Successfully Uploaded");
        }

        if (
          responseData.data.StageDetails.Documents.pancard &&
          responseData.data.StageDetails.Documents.pancard.pancard_url
        ) {
          setpancardUrl(
            responseData.data.StageDetails.Documents.pancard.pancard_url
          );
        }

        if (
          responseData.data.StageDetails.Documents.signature &&
          responseData.data.StageDetails.Documents.signature.signature_url
        ) {
          setsignatureUrl(
            responseData.data.StageDetails.Documents.signature.signature_url
          );
        }
        if (
          responseData.data.StageDetails.Documents.bank_proof &&
          responseData.data.StageDetails.Documents.bank_proof.bank_proof_url
        ) {
          setbankProofUrl(
            responseData.data.StageDetails.Documents.bank_proof.bank_proof_url
          );
        }
        if (
          responseData.data.StageDetails.Documents.gst_proof &&
          responseData.data.StageDetails.Documents.gst_proof.gst_proof_url
        ) {
          setGstUrl(
            responseData.data.StageDetails.Documents.gst_proof.gst_proof_url
          );
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
        setBackDropLoading(false);
      });
  }, []);

  const handleSignatureDocumentID = (data: any) => {
    //  console.log("dataSignature", data);

    setdisableContinueOption1(data);

    setUploadmessage(data);
    setTimeout(() => {
      setUploadmessage("");
    }, 5000);
  };
  const handleBankProofDocumentID = (data: any) => {
    //  console.log("dataSignature", data);

    setdisableContinueOption4(data);

    setUploadmessage(data);
    setTimeout(() => {
      setUploadmessage("");
    }, 5000);
  };
  const handlePanDocumentID = (data: any) => {
    // console.log("panCradData", data);

    setdisableContinueOption2(data);

    setUploadmessage(data);
    setTimeout(() => {
      setUploadmessage("");
    }, 5000);
  };
  const handleGstDocumentID = (data: any) => {
    // console.log("panCradData", data);

    setdisableContinueOption3(data);

    setUploadmessage(data);
    setTimeout(() => {
      setUploadmessage("");
    }, 5000);
  };

  return (
    <div className={uploadStyles.mainWrapperTop}>
      <StageLayout
        completedStages={completedStages}
        stageName={"Upload Documents"}
        navigatePath={"/linkusingifsc"}
      />

      <div className={uploadStyles.wrapper}>
        <div className={uploadStyles.headerSection}>
          <p className={uploadStyles.signup}>Upload Your Documents</p>
        </div>
        {!backLoading ? (
          <>
            <div className={uploadStyles.uploadSignatureSection}>
              <div>
                <p className={uploadStyles.subText}> Upload Your Signature </p>
              </div>
              <div>
                <FormatterChecker
                  previewImage={handlePreview}
                  acceptedFormats={chequeFormat}
                  documentRef={signatureDocRef}
                  documentID={handleSignatureDocumentID}
                  displayOptions={""}
                  stageDetailsData={signatureUrl}
                  name="signature"
                  purpose={"signature"}
                  pdfSize={UploadSizes["signature"].pdfSize}
                  imageSize={UploadSizes["signature"].imageSize}
                />
              </div>
            </div>
            <div className={uploadStyles.uploadSignatureSection}>
              <div>
                <p className={uploadStyles.subText}> Upload Pan Card </p>
              </div>
              <div>
                <FormatterChecker
                  previewImage={handlePreview}
                  acceptedFormats={formats}
                  documentRef={panCardDocRef}
                  documentID={handlePanDocumentID}
                  displayOptions={""}
                  stageDetailsData={pancardUrl}
                  name="pancard"
                  purpose={"pancard"}
                  pdfSize={UploadSizes["pancard"].pdfSize}
                  imageSize={UploadSizes["pancard"].imageSize}
                />
              </div>
            </div>
            <div className={uploadStyles.uploadSignatureSection}>
              <div>
                <p className={uploadStyles.subText}> Upload GST (OPTIONAL) </p>
              </div>
              <div>
                <FormatterChecker
                  previewImage={handlePreview}
                  acceptedFormats={formats}
                  documentRef={"gst_proof"}
                  documentID={handleGstDocumentID}
                  displayOptions={""}
                  stageDetailsData={gstUrl}
                  name="gst_proof"
                  purpose={"gst_proof"}
                  pdfSize={UploadSizes["gst_proof"].pdfSize}
                  imageSize={UploadSizes["gst_proof"].imageSize}
                />
              </div>
            </div>

            <SucessSnackBar message={uploadmessage} />
            <div className={uploadStyles.infoSection}>
              <>
                {InformationMessage !== "" && <InfoOutlinedIcon />}{" "}
                {InformationMessage}
              </>
            </div>
            <div className={uploadStyles.uploadSignatureSection}>
              <div>
                <p className={uploadStyles.subText}>
                  {" "}
                  Copy of Cancelled Cheque/Statement{" "}
                </p>
              </div>
              <div>
                <FormatterChecker
                  previewImage={handlePreview}
                  acceptedFormats={formats}
                  documentRef={"bank_proof"}
                  documentID={handleBankProofDocumentID}
                  displayOptions={""}
                  stageDetailsData={bankProofeUrl}
                  name="bank_proof"
                  purpose={"bank_proof"}
                  pdfSize={UploadSizes["bank_proof"].pdfSize}
                  imageSize={UploadSizes["bank_proof"].imageSize}
                />
              </div>
            </div>

            <div
              className={uploadStyles.messageSection}
              style={{ alignItems: "center", display: "flex", marginTop: 0 }}
            >
              <InfoOutlinedIcon />{" "}
              <span>
                Copy of cancelled cheque with your name or latest bank statement
                that shows
              </span>
            </div>
            <div className={uploadStyles.messageSection}>
              <ul
                style={{
                  marginTop: "10px",
                  paddingLeft: "15px",
                  fontWeight: "bold",
                }}
              >
                <li> Your bank account number {bankDetails.AccountNumber} </li>
              </ul>
            </div>
            <div className={uploadStyles.messageSection}>
              <ul
                style={{
                  marginTop: 0,
                  paddingLeft: "15px",
                  fontWeight: "bold",
                }}
              >
                <li> IFSC Code {bankDetails.IFSCCode} </li>
              </ul>
            </div>

            <SnackBar message={message} />
            {backdrop && <StartOverBackDrop />}
            <div className={uploadStyles.buttonStack}>
              <div>
                {disableContinueOption1 === "Document Successfully Uploaded" &&
                disableContinueOption2 === "Document Successfully Uploaded" &&
                // disableContinueOption3 === "Document Successfully Uploaded" &&
                disableContinueOption4 === "Document Successfully Uploaded" ? (
                  <LoadingButton
                    variant="contained"
                    onClick={handleStageAPI}
                    loading={loading}
                    id="upLoadDocumentsContinueButton"
                    className={uploadStyles.approveButton}
                  >
                    {" "}
                    Continue
                  </LoadingButton>
                ) : (
                  <LoadingButton
                    variant="contained"
                    // onClick={handleClick}
                    loading={loading}
                    disabled
                    id="upLoadDocumentsContinueButton"
                    className={uploadStyles.approveButton}
                  >
                    {" "}
                    Continue
                  </LoadingButton>
                )}
              </div>
              <div className={uploadStyles.startOverSection}>
                <img src={icon} className={uploadStyles.iconImage} />
                <p className={uploadStyles.paratext}>
                  {" "}
                  if the above mentioned info not yours
                  <span
                    className={uploadStyles.startoverbutton}
                    onClick={handleStartOver}
                  >
                    Start Over
                  </span>
                </p>
              </div>
            </div>
          </>
        ) : (
          <div style={{ height: "65vh" }}>
            <BackDrop />
          </div>
        )}
      </div>
    </ div>
  );
}
